import { useMemo } from 'react';

import { selectTourState } from 'features/tour/tourSelectors';

import { useAppSelector } from 'hooks/useTypedRedux';

export const useGetActiveSidebarItemId = (
  allowedTabs: Set<number>,
  openItemId?: number
): number | undefined => {
  const tourState = useAppSelector(selectTourState);

  return useMemo(() => {
    if (!tourState.tourActive) {
      return openItemId;
    }

    const nextStepIndex = tourState.nextStepIndex ?? tourState.stepIndex;
    const nextStep = tourState.steps[nextStepIndex];
    const targetTab = nextStep?.targetTab;

    if (targetTab && allowedTabs.has(targetTab)) {
      return targetTab;
    }

    return openItemId;
  }, [
    allowedTabs,
    tourState.steps,
    tourState.stepIndex,
    tourState.nextStepIndex,
    tourState.tourActive,
    openItemId
  ]);
};
